import React, { Component } from "react";
import { Link } from "uniRouter";
import styled, { cx } from "react-emotion";
import { withTheme } from "emotion-theming";
// import theme from "components/theme";
// import baseStyles from "./styles.module.css";

function Button(props) {
  const {
    isUpdating,
    updatingText,
    text,
    children,
    motif = "primary",
    className,
    inGroup = false,
    href,
    size = "",
    wide = false,
    disabled = false,
    type = "button",
    tag = "button",
    theme,
    target = null,
    ...rest
  } = props;

  const Tag = href && tag === "button" && !disabled ? Link : tag;

  return (
    <Tag
      {...rest}
      href={Tag === Link ? null : href}
      to={Tag === Link ? href : null}
      type={type}
      disabled={disabled}
      className={cx(wide && "wide", size, className, motif, inGroup && "btn")}
      target={Tag === Link || tag === "a" ? target : null}
    >
      {isUpdating ? updatingText : text || children}
    </Tag>
  );
}

Button = withTheme(Button);
Button = styled(Button)`
  ${props => props.theme.buttons[props.motif || "primary"]};
`;

// const LinkButton = props => {
//   const Tag = props.href ? Link : "a";

//   return (
//     <Tag
//       className={baseStyles.linkButton}
//       onClick={props.onClick}
//       to={props.href}
//       target={props.target}
//       href={props.href ? null : "javascript:void(0);"}
//     >
//       {props.text || props.children}
//     </Tag>
//   );
// };

// const Button = props => (props.type === "link" ? <LinkButton {...props} /> : <BoxButton {...props} />);

export default Button;
